<template>
  <div class="mt-2 px-2">
    <b-row>
      <b-col cols="12">
        <div class="pl-2 py-25 mb-4 mb-lg-50" style="width: 65px; height: 65px">
          <span class="cell-fit h1 mb-2 font-weight-light">One last step,</span>
          <br />
          <span class="h1 font-weight-bolder position-absolute">
            before hosting your first competition!
          </span>
        </div>
        <div class="pl-2 pt-2">
          <span class="h3 font-weight-light">
            Please follow the steps to finalize your registration as a partner
          </span>
        </div>
        <div class="mt-5 d-flex flex-wrap font-weight-light">
          <div class="col-md-8 col-12 px-sm-2">
            <span class="h1 font-weight-bolder">
              1.Upload a valid government-issued documnet
            </span>
            <div class="pt-2">
              <span class="h3 font-weight-light">
                Please note, that the information you provide here must match
                the information you entered while registring as a partner
              </span>
            </div>

            <ul class="pl-0 step3-list pt-2 rounded-pills font-weight-light h4">
              <li class="my-50">
                Accepted documents include: Driver's license, Passport,
                Government-issued ID card
              </li>
              <li class="my-50">
                You must upload a high-quality photo (fron and back) that is not
                manipulated by any software
              </li>
              <li class="my-50">
                Your photo must be colored (black and white is not accepted)
              </li>
              <li class="my-50">
                While takin the photo, place the document against a solid
                background
              </li>
            </ul>
            <!-- <b-alert
              variant="warning"
              v-if="Object.keys(idCartFront).length"
              show
              fade
              class="p-1"
            >
              Your front image has been uploded.
            </b-alert> -->
            <!-- <b-alert
              variant="warning"
              v-if="Object.keys(idCartBack).length"
              show
              fade
              class="p-1"
            >
              Your back image has been uploded.
            </b-alert> -->
            <div class="w-100 d-flex my-2 flex-wrap">
              <div class="d-flex flex-column mr-2">
                <div
                  v-if="idCartFront"
                  style="max-width: 300px; max-height: 300px"
                  class="d-flex justify-content-center align-items-center mb-2 mx-1"
                >
                  <b-img
                    class="img-fluid rounded-lg my-auto"
                    :src="idCartFront.url || errorImage"
                    @error="setAltImg"
                    alt="id-cart-front"
                    style="max-height: 300px"
                  />
                </div>
                <template v-if="idCartFront && idCartFront.url">
                  <b-button
                    v-if="idCartFront.status != 'ACCEPTED'"
                    variant="danger rounded-pill font-weight-bolder mx-1 mt-auto"
                    size="lg"
                    @click="remove(idCartFront.id)"
                  >
                    Remove front
                  </b-button>
                </template>
                <b-button
                  v-else
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="info rounded-pill font-weight-bolder mx-1 "
                  size="lg"
                  @click="$refs.front.click()"
                >
                  <input
                    @input="upload($event, 'ID_CARD_FRONT')"
                    ref="front"
                    type="file"
                    class="d-none"
                    accept="image/*"
                  />
                  Upload front
                </b-button>
                <div v-if="idCartFront" class="d-flex flex-column p-1">
                  <div>Upload front</div>
                  <div>
                    <span> Status : </span>
                    <b-badge
                      :variant="
                        idCartFront.status == 'PENDING'
                          ? 'warning'
                          : idCartFront.status == 'REJECTED'
                          ? 'danger'
                          : 'success'
                      "
                      >{{ idCartFront.status }}</b-badge
                    >
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div
                  v-if="idCartBack"
                  style="max-width: 300px; max-height: 300px"
                  class="d-flex justify-content-center align-items-center mb-2 mx-1"
                >
                  <b-img
                    class="img-fluid rounded-lg my-auto"
                    :src="idCartBack.url || errorImage"
                    @error="setAltImg"
                    alt="id-cart-back"
                    style="max-height: 300px"
                  />
                </div>
                <template v-if="idCartBack && idCartBack.url">
                  <b-button
                    v-if="idCartBack.status != 'ACCEPTED'"
                    variant="danger rounded-pill font-weight-bolder mx-1 mt-auto"
                    size="lg"
                    @click="remove(idCartBack.id)"
                  >
                    Remove back
                  </b-button>
                </template>
                <b-button
                  v-else
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="info rounded-pill font-weight-bolder mx-1"
                  size="lg"
                  @click="$refs.back.click()"
                >
                  <input
                    @input="upload($event, 'ID_CARD_BACK')"
                    ref="back"
                    type="file"
                    class="d-none"
                    accept="image/*"
                  />
                  Upload back
                </b-button>
                <div v-if="idCartBack" class="d-flex flex-column p-1">
                  <div>Upload back</div>
                  <div>
                    <span> Status : </span>
                    <b-badge
                      v-if="idCartBack"
                      :variant="
                        idCartBack.status == 'PENDING'
                          ? 'warning'
                          : idCartBack.status == 'REJECTED'
                          ? 'danger'
                          : 'success'
                      "
                      >{{ idCartBack.status }}</b-badge
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div
              style="max-height: 250px"
              class="w-100 d-flex justify-content-center align-items-center mb-4"
            >
              <b-img
                style="max-height: 250px; width: 370px !important"
                fluid
                class="w-100"
                :src="
                  require('@/assets/images/fxlegends/icon-09-subscriptionAsset 15.svg')
                "
              />
            </div>
            <div
              style="max-height: 250px"
              class="w-100 d-flex justify-content-center"
            >
              <b-img
                style="max-height: 200px; width: 400px !important"
                fluid
                :src="
                  require('@/assets/images/fxlegends/icon-10-subscriptionAsset 16.svg')
                "
              />
            </div>
          </div>
        </div>
        <div class="mt-5 d-flex flex-wrap">
          <div class="col-md-8 col-12 px-sm-2">
            <span class="h1 font-weight-bolder">
              2.Take a selfie with the text below
            </span>
            <div class="pt-2 pr-4">
              <span class="h3 text-warning font-weight-light">
                My full name is ....... and I am intending to become a partner
                member at FX Legends.com website. Date: xx/yy/zz Signature: ...
              </span>
            </div>

            <ul class="pl-0 step3-list pt-2 rounded-pills font-weight-light h4">
              <li class="my-50">Write the text in your own handwriting.</li>
              <li class="my-50">
                Use sufficatient lightning while taking the photo.
              </li>
              <li class="my-50">
                Do not wear a mask or other accessories that might cover-up your
                face.
              </li>
            </ul>

            <div class="w-100 d-flex align-items-center my-2 flex-wrap">
              <div class="d-flex flex-column mr-2">
                <div
                  v-if="portrait"
                  style="max-width: 300px; max-height: 300px"
                  class="mx-1 mb-2"
                >
                  <b-img
                    class="img-fluid rounded-lg"
                    style="max-height: 300px"
                    :src="portrait.url || errorImage"
                    @error="setAltImg"
                    alt="portrait"
                  />
                </div>
                <template v-if="portrait && portrait.url">
                  <b-button
                    v-if="portrait.status != 'ACCEPTED'"
                    variant="danger rounded-pill font-weight-bolder mx-1"
                    size="lg"
                    @click="remove(portrait.id)"
                  >
                    Remove selfie
                  </b-button>
                </template>
                <b-button
                  v-else
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="info rounded-pill font-weight-bolder mx-1"
                  size="lg"
                  @click="$refs.selfie.click()"
                >
                  <input
                    @input="upload($event, 'PORTRAIT')"
                    ref="selfie"
                    type="file"
                    class="d-none"
                    accept="image/*"
                  />
                  Upload selfie
                </b-button>

                <div v-if="portrait" class="d-flex flex-column p-1">
                  <div>Upload selfie</div>
                  <div>
                    <span> Status : </span>
                    <b-badge
                      :variant="
                        portrait.status == 'PENDING'
                          ? 'warning'
                          : portrait.status == 'REJECTED'
                          ? 'danger'
                          : 'success'
                      "
                      >{{ portrait.status }}</b-badge
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12 d-flex mt-2">
            <div class="w-100 d-flex justify-content-center position-relative">
              <b-img
                style="height: 200px; width: 200px"
                fluid
                :src="
                  require('@/assets/images/fxlegends/icon-08-subscriptionAsset 14.svg')
                "
              />
              <div
                class="position-absolute left-0 top-0"
                style="height: 20px; width: 20px"
              >
                <b-img
                  style="max-height: 20px"
                  fluid
                  :src="
                    require('@/assets/images/fxlegends/icon-06-subscriptionAsset 12.svg')
                  "
                />
              </div>
            </div>
            <div class="w-100 d-flex justify-content-center position-relative">
              <b-img
                style="
                  height: 200px;
                  width: 200px;
                  transform: scale(0.8) translateY(-5px);
                "
                fluid
                :src="
                  require('@/assets/images/fxlegends/icon-07-subscriptionAsset 13.svg')
                "
              />
              <div
                class="position-absolute left-0 top-0"
                style="height: 20px; width: 20px"
              >
                <b-img
                  style="max-height: 20px"
                  fluid
                  :src="
                    require('@/assets/images/fxlegends/icon-05-subscriptionAsset 10.svg')
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <template v-if="userData.status == 'REJECTED'">
          <div class="my-2 w-100">
            <hr />
          </div>
          <div class="mt-5 d-flex flex-wrap font-weight-light">
            <div class="col-12 px-sm-2">
              <h1 class="font-weight-bolder text-danger">Rejected</h1>
              <h4 class="font-weight-bolder">{{ reason }}</h4>
              <div class="w-100 d-flex align-items-end my-2 flex-wrap">
                <div class="w-100">
                  <div class="w-100 d-flex flex-wrap">
                    <b-col
                      md="3"
                      cols="12"
                      v-for="(other, index) in others"
                      :key="index"
                      class="d-flex flex-column justify-content-center align-items-center mb-2"
                    >
                      <div
                        class="d-flex flex-column justify-content-center align-items-center h-100"
                      >
                        <b-img
                          class="img-fluid rounded-lg my-auto"
                          :src="other.url || errorImage"
                          @error="setAltImg"
                          alt="id-cart-front"
                          style="max-height: 250px"
                        />
                        <div class="mt-auto pt-1">
                          <b-button
                            variant="danger rounded-pill font-weight-bolder mx-1 "
                            size="lg"
                            @click="remove(other.id)"
                          >
                            Remove
                          </b-button>
                        </div>
                      </div>
                    </b-col>
                  </div>

                  <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="info rounded-pill font-weight-bolder "
                    size="lg"
                    @click="$refs.other.click()"
                  >
                    <input
                      @input="upload($event, 'OTHER')"
                      ref="other"
                      type="file"
                      class="d-none"
                      accept="image/*"
                    />
                    Upload Other Documents
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </b-col>
    </b-row>
    <b-row>
      <b-button
        variant="danger"
        class="py-1 ml-auto"
        @click="$emit('getProfile', true)"
        >Finish</b-button
      >
    </b-row>
    <loader :loading="loading" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BImg,
  BButton,
  BListGroup,
  BListGroupItem,
  BAlert,
  BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import loader from "@core/components/loader/Loader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BButton,
    BListGroup,
    BListGroupItem,
    BAlert,
    loader,
    BBadge,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      reason: "",
    };
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData;
    },
    documents() {
      return this.userData.documents || [];
    },
    idCartFront() {
      let index = this.documents.findIndex(
        (item) => item.type == "ID_CARD_FRONT"
      );
      return index > -1 ? this.documents[index] : false;
    },
    idCartBack() {
      let index = this.documents.findIndex(
        (item) => item.type == "ID_CARD_BACK"
      );
      return index > -1 ? this.documents[index] : false;
    },
    portrait() {
      let index = this.documents.findIndex((item) => item.type == "PORTRAIT");
      return index > -1 ? this.documents[index] : false;
    },
    others() {
      return this.documents.filter((item) => item.type == "OTHER");
    },
  },
  async created() {
    this.userData.status == "REJECTED" && this.getReason();
  },
  methods: {
    async getReason() {
      try {
        const { data } = await this.$http.get("/panel/reject");
        this.reason = data.data.reason;
      } catch (error) {}
    },
    async upload(e, type) {
      this.loading = true;
      let formData = new FormData();
      formData.append("content", e.target.files[0]);
      formData.append("type", type);
      try {
        const { data } = await this.$http.post("/panel/documents", formData);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "your document is uploaded",
            icon: "BellIcon",
          },
        });
        await this.$emit("getProfile");
      } catch (err) {}

      this.loading = false;
    },
    async remove(id) {
      this.loading = true;
      try {
        const { data } = await this.$http.delete("/panel/documents/" + id);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "your document is deleted",
            icon: "BellIcon",
          },
        });
        await this.$emit("getProfile");
      } catch (error) {}
      this.loading = false;
    },
  },
};
</script>
